import { useRedux } from "hooks";
import React, { useEffect, useState, useRef, useCallback } from "react";
import { Form, Button, Modal, ModalHeader, ModalBody, ModalFooter, Label, Input, Spinner } from "reactstrap";
import { createSelector } from "reselect";
import AppSimpleBar from "./AppSimpleBar";
import { debounce } from "lodash";
import { Tab, Tabs } from "react-bootstrap";
import { FILTER_CHAT_ROOM_TABS } from "../constants";
import TextBox from "./TextBox";
import { findForFilterChatroomSale, findForFilterChatroomCs, findForFilterChatroomProvince } from "../redux/actions";
import UserAvatar from "./UserAvatar";
import { Const } from "const";
import { Utils } from "helpers/utils";

export interface FilterConfig {
    selTab: FILTER_CHAT_ROOM_TABS,
    unRead: boolean | null,
    personUnRead: boolean | null,
    topRow: number,
    noActivity: boolean | null,
    keywordChatRoom: string,
    keywordSales: string,
    keywordCs: string,
    keywordProvince: string,
    keySelected: any[],
    customerIsCdSys: string,
}

interface FilterChatRoomModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSelectChat: (id: number | string) => void;
    // keySelected: any[];
    // onKeySelected: (mode: FILTER_CHAT_ROOM_TABS, keyId: any, keyDisplay: string) => void;
    // onKeySelectedDel: (keyDisplay: string) => void;
    filterChatRoom: FilterConfig;
    setFilterChatRoom: React.Dispatch<React.SetStateAction<FilterConfig>>;
}

const FilterChatRoomModal = ({
    isOpen,
    onClose,
    onSelectChat,
    // keySelected,
    // onKeySelected,
    // onKeySelectedDel,
    filterChatRoom,
    setFilterChatRoom,
}: FilterChatRoomModalProps) => {
    const { dispatch, useAppSelector } = useRedux();
    const storeData = createSelector(
        (state) => state.Profile2,
        (state) => state.Chats,
        (state, chat) => ({
            // groupInviteCode: state.groupInviteCode,
            // groupInviteOn: state.groupInviteOn,
            profile2: state,

            filterRsChatRooms: chat.filterRsChatRooms,
            filterRsSales: chat.filterRsSales,
            filterRsCs: chat.filterRsCs,
            filterRsProvince: chat.filterRsProvince,

            filteringChatRooms: chat.filteringChatRooms,
            filteringSales: chat.filteringSales,
            filteringCs: chat.filteringCs,
            filteringProvince: chat.filteringProvince,

        })
    );
    const [filterChatRoomTmp, setFilterChatRoomTmp] = useState<FilterConfig>(filterChatRoom);
    useEffect(() => {
        // console.log('FilterChatRoomModalRender');
    }, []);

    const {
        filterRsChatRooms, filterRsSales, filterRsCs, filterRsProvince
        , filteringChatRooms, filteringSales, filteringCs, filteringProvince

    } = useAppSelector(storeData);

    const debounceSearchDropDownSale = useCallback(
        debounce((unRead: boolean | null, personUnRead: boolean | null, noActivity: boolean | null, topRow: number, filterKeyword: string | null) => {
            dispatch(findForFilterChatroomSale(unRead, personUnRead, noActivity, topRow, filterKeyword));
        }, 1000)
        , []);
    const debounceSearchDropDownCs = useCallback(
        debounce((unRead: boolean | null, personUnRead: boolean | null, noActivity: boolean | null, topRow: number, filterKeyword: string | null) => {
            dispatch(findForFilterChatroomCs(unRead, personUnRead, noActivity, topRow, filterKeyword));
        }, 1000)
        , []);
    const debounceSearchDropDownProvince = useCallback(
        debounce((unRead: boolean | null, personUnRead: boolean | null, noActivity: boolean | null, topRow: number, filterKeyword: string | null) => {
            dispatch(findForFilterChatroomProvince(unRead, personUnRead, noActivity, topRow, filterKeyword));
        }, 1000)
        , []);

    const searchApi = (bSearchSale: boolean, bSearchCs: boolean, bSearchProvince: boolean, bSearchNow: boolean, filter: FilterConfig) => {
        // console.log(`search sale=${bSearchSale}, cs=${bSearchCs}, province=${bSearchProvince}`);
        if (bSearchSale) {
            if (bSearchNow) {
                dispatch(findForFilterChatroomSale(filter.unRead, filter.personUnRead, filter.noActivity, filter.topRow, filter.keywordSales));
            } else {
                // เปลี่ยนเป็นให้ค้นจาก enter
                //debounceSearchDropDownSale(filter.unRead, filter.personUnRead, filter.noActivity, filter.topRow, filter.keywordSales);
            }
        }
        if (bSearchCs) {
            if (bSearchNow) {
                dispatch(findForFilterChatroomCs(filter.unRead, filter.personUnRead, filter.noActivity, filter.topRow, filter.keywordCs));
            } else {
                // เปลี่ยนเป็นให้ค้นจาก enter
                //debounceSearchDropDownCs(filter.unRead, filter.personUnRead, filter.noActivity, filter.topRow, filter.keywordCs);
            }
        }
        if (bSearchProvince) {
            if (bSearchNow) {
                dispatch(findForFilterChatroomProvince(filter.unRead, filter.personUnRead, filter.noActivity, filter.topRow, filter.keywordProvince));
            } else {
                // เปลี่ยนเป็นให้ค้นจาก enter
                //debounceSearchDropDownProvince(filter.unRead, filter.personUnRead, filter.noActivity, filter.topRow, filter.keywordProvince);
            }
        }
    }

    // const [filter, setFilter] = useState<FilterConfig>(loadFilter());
    const [selectedTabIn, setSelectedTabIn] = useState<FILTER_CHAT_ROOM_TABS>(FILTER_CHAT_ROOM_TABS.SALES/* selectedTab*/);

    const handleTabSelect = (tabKey: string | null) => {
        const selTab = tabKey as FILTER_CHAT_ROOM_TABS;
        setSelectedTabIn(selTab);
    }
    type SENDERS = "UnRead" | "Person Unread" | "NoActivity" | "FilterText" | "DropDownTop" | "TabPage" | "CustomerIsCdSys";

    const onFilterChange = async (sender: SENDERS, value: any) => {
        let updatedFilterChatRoom = { ...filterChatRoomTmp };

        let bSearchSale = false;
        let bSearchCs = false;
        let bSearchProvince = false;
        let bSearchNow = false;

        switch (sender) {
            case "DropDownTop":
                updatedFilterChatRoom.topRow = value;

                bSearchSale = bSearchCs = bSearchProvince = bSearchNow = true;
                break;

            case "CustomerIsCdSys":
                updatedFilterChatRoom.customerIsCdSys = value;
                break;

            case "FilterText":
                if (value == "--FilterEnter--") {
                    bSearchNow = true;
                } else {
                    updatedFilterChatRoom = {
                        ...updatedFilterChatRoom,
                        keywordChatRoom: filterChatRoomTmp.selTab === FILTER_CHAT_ROOM_TABS.CHAT_ROOM ? value : filterChatRoomTmp.keywordChatRoom,
                        keywordSales: filterChatRoomTmp.selTab === FILTER_CHAT_ROOM_TABS.SALES ? value : filterChatRoomTmp.keywordSales,
                        keywordCs: filterChatRoomTmp.selTab === FILTER_CHAT_ROOM_TABS.CS ? value : filterChatRoomTmp.keywordCs,
                        keywordProvince: filterChatRoomTmp.selTab === FILTER_CHAT_ROOM_TABS.PROVINCE ? value : filterChatRoomTmp.keywordProvince,
                    };
                }

                bSearchSale = filterChatRoomTmp.selTab === FILTER_CHAT_ROOM_TABS.SALES;
                bSearchCs = filterChatRoomTmp.selTab === FILTER_CHAT_ROOM_TABS.CS;
                bSearchProvince = filterChatRoomTmp.selTab === FILTER_CHAT_ROOM_TABS.PROVINCE;
                break;

            case "NoActivity":
                updatedFilterChatRoom.noActivity = value;
                break;

            case "Person Unread":
                updatedFilterChatRoom.personUnRead = value;

                bSearchSale = bSearchCs = bSearchNow = true;
                break;

            case "TabPage":
                updatedFilterChatRoom.selTab = value;
                break;

            case "UnRead":
                updatedFilterChatRoom.unRead = value;
                break;

            default:
                return; // Exit if sender is invalid
        }

        // Update state with the modified object
        // console.log('updatedFilterChatRoom:', updatedFilterChatRoom);
        // setFilterChatRoom(updatedFilterChatRoom);
        setFilterChatRoomTmp(updatedFilterChatRoom);
        searchApi(bSearchSale, bSearchCs, bSearchProvince, bSearchNow, updatedFilterChatRoom);
        // await fetchAPI(updatedFilterChatRoom);
    }

    // useEffect(() => { console.log('filterChatRoomTmp:', filterChatRoomTmp) }, [filterChatRoomTmp]);

    const onKeySelectedInside = async (mode: FILTER_CHAT_ROOM_TABS, keyId: any, keyDisplay: string) => {
        let updatedFilterChatRoom = { ...filterChatRoomTmp };
        // updatedFilterChatRoom.ticks = updatedFilterChatRoom.ticks + 1;

        const val = { mode, keyId, keyDisplay }

        // Check if the uniqueKey exists in the array
        const isAlreadySelected = updatedFilterChatRoom.keySelected.some(item => item.mode == mode && item.keyId == keyId);
        if (isAlreadySelected) {
            // If the key exists, remove it
            updatedFilterChatRoom.keySelected = updatedFilterChatRoom.keySelected.filter(item => !(item.mode == mode && item.keyId == keyId));
        } else {
            // If the key doesn't exist, add it
            updatedFilterChatRoom.keySelected = [...updatedFilterChatRoom.keySelected, val];
        }

        console.log(updatedFilterChatRoom.keySelected);

        setFilterChatRoomTmp(updatedFilterChatRoom);
        //onKeySelected(mode, keyId, keyDisplay);
    }

    const onKeySelectedDel = (keyDisplay: string) => {
        let updatedFilterChatRoom = { ...filterChatRoomTmp };
        updatedFilterChatRoom.keySelected = updatedFilterChatRoom.keySelected.filter(item => item.keyDisplay != keyDisplay);
        setFilterChatRoomTmp(updatedFilterChatRoom);
    }

    const onClickOk = async () => {
        setFilterChatRoom(filterChatRoomTmp);
        onClose();
    }

    const Searching = (mode: FILTER_CHAT_ROOM_TABS, filterValue: string) => {
        // const txtFilter = useRef<HTMLInputElement | null>(null);
        const [txtFilter, setTxtFilter] = useState<string>(filterValue);
        const placeHolderText = () => {
            if (mode == FILTER_CHAT_ROOM_TABS.CHAT_ROOM) return "ใส่ชื่อ ห้องแชท";
            if (mode == FILTER_CHAT_ROOM_TABS.SALES) return "ใส่ชื่อ เซลล์";
            if (mode == FILTER_CHAT_ROOM_TABS.CS) return "ใส่ชื่อ CS";
            if (mode == FILTER_CHAT_ROOM_TABS.PROVINCE) return "ใส่ชื่อ จังหวัด";
            return mode;
        }

        const filterMap = {
            [FILTER_CHAT_ROOM_TABS.CHAT_ROOM]: filterRsChatRooms,
            [FILTER_CHAT_ROOM_TABS.SALES]: filterRsSales,
            [FILTER_CHAT_ROOM_TABS.CS]: filterRsCs,
            [FILTER_CHAT_ROOM_TABS.PROVINCE]: filterRsProvince
        };

        const listData = filterMap[mode] || [];

        return (
            <>
                <div className="row">
                    <div className="col">
                        <TextBox
                            placeholder={placeHolderText()}
                            className="form-control mb-2"
                            onChange={(e) => onFilterChange("FilterText", e.target.value)}
                            onEnter13={(e) => onFilterChange("FilterText", "--FilterEnter--")}
                            icon13css="bx bx-search"
                            value={txtFilter}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <AppSimpleBar className="filter-chat-room-modal-result">
                            <ul className="list-unstyled">
                                {/*mode == FILTER_CHAT_ROOM_TABS.CHAT_ROOM &&*/
                                    (listData ?? []).map((ee: any, index: number) => {
                                        return (
                                            <li key={index} className="mb-2 hover hand" onClick={() => onKeySelectedInside(mode, ee.keyId, ee.displayName)}>
                                                <div className="d-flex align-items-center">
                                                    <UserAvatar
                                                        profileImage={ee.profileImage}
                                                        bgColor={ee.bgColor}
                                                        foreColor={ee.foreColor}
                                                        abbrName={ee.abbrName}
                                                    />
                                                    <div className="flex-grow-1 overflow-hidden">
                                                        <p className="text-truncate mb-0">
                                                            {ee.displayName}
                                                        </p>
                                                    </div>
                                                    <div className="ms-auto text-end">
                                                        <div>
                                                            {/* {ee.groupCount > 0 && (<p className="text-truncate mb-0" >{ee.groupCount}</p>)}
                                                            {ee.unreadCount > 0 && (<p className="text-truncate mb-0 text-red" >{ee.unreadCount}</p>)} */}

                                                            {(mode == FILTER_CHAT_ROOM_TABS.CHAT_ROOM && ee.unreadCount > 0) && (
                                                                <>
                                                                    <span className="badge badge-soft-danger bg-danger">{ee.unreadCount}</span>
                                                                </>
                                                            )}

                                                            {(mode == FILTER_CHAT_ROOM_TABS.SALES || mode == FILTER_CHAT_ROOM_TABS.CS) ? (
                                                                <>
                                                                    {ee.groupCount > 0 && (<span className="badge badge-soft-secondary bg-secondary">{ee.groupCount}</span>)}
                                                                    &nbsp;
                                                                    {ee.unreadCount > 0 && (<span className="badge badge-soft-danger bg-danger">{ee.unreadCount}</span>)}
                                                                </>
                                                            ) : null}

                                                            {mode == FILTER_CHAT_ROOM_TABS.PROVINCE && (
                                                                <>
                                                                    {ee.groupCount > 0 && (<span className="badge badge-soft-danger bg-secondary">{ee.groupCount}</span>)}
                                                                </>
                                                            )}


                                                        </div>
                                                    </div>
                                                    <div className="ms-auto text-end" style={{ paddingLeft: "2px", paddingTop: "3px" }}>
                                                        <span className={"mdi " + (filterChatRoomTmp.keySelected.some(e => e.mode == mode && e.keyId == ee.keyId) ? 'mdi-minus-circle text-danger' : 'mdi-plus-circle text-success')} style={{ fontSize: "1.5em" }} ></span>
                                                    </div>
                                                </div>
                                            </li>)
                                    })
                                }


                            </ul>
                        </AppSimpleBar>
                    </div>
                </div>
            </>
        )
    }

    return (
        <Modal isOpen={isOpen} toggle={onClose} tabIndex={-1} centered scrollable >
            <ModalHeader className="bg-primary" toggle={onClose}>
                <div className="modal-title-custom text-white font-size-16 ">
                    กรองห้องแชท
                </div>
            </ModalHeader>
            <ModalBody className="p-3">
                <Form>
                    <div className="row">
                        <div className="col">
                            <div className="d-flex justify-content-start align-items-center mb-1">
                                <div className="me-2">ประเภทห้องแชท</div>
                                <div>

                                    <select className="form-control p-1" value={filterChatRoomTmp.customerIsCdSys} onChange={(e) => onFilterChange("CustomerIsCdSys", e.target.value)}>
                                        <option value="">ทั้งหมด</option>
                                        <option value="1">DConnect</option>
                                        <option value="2">2S Online</option>
                                        <option value="-1">ยังไม่จับบริษัท</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div className="d-flex flex-wrap">
                                {/* un read */}
                                <div >
                                    <input type="checkbox" id="chkUnRead" checked={filterChatRoomTmp.unRead ?? false} onChange={(e) => onFilterChange("UnRead", e.target.checked)} ></input>&nbsp;<label htmlFor="chkUnRead">Unread</label>
                                </div>
                                &nbsp;&nbsp;
                                {/* sale/cs not yet read */}
                                <div >
                                    <input type="checkbox" id="chkPersonUnRead" checked={filterChatRoomTmp.personUnRead ?? false} onChange={(e) => onFilterChange("Person Unread", e.target.checked)} ></input>&nbsp;<label htmlFor="chkPersonUnRead">Sale/CS Unread</label>
                                </div>
                                &nbsp;&nbsp;
                                {/* long time not read */}
                                <div >
                                    <input id="chkLongTime" type="checkbox" checked={filterChatRoomTmp.noActivity ?? false} onChange={(e) => onFilterChange("NoActivity", e.target.checked)} ></input>&nbsp;<label htmlFor="chkLongTime" title={`ไม่เคลื่อนไหว เกิน ${Const.CHATROOM_NO_ACTIVITY_DAY} วัน`}>ไม่เคลื่อนไหว</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            {(filterChatRoomTmp.keySelected || []).map((ee: any, index: number) => (
                                <span key={index} className="no-wrap tag">
                                    <span className="mdi mdi-minus-circle text-danger hand" onClick={() => onKeySelectedDel(ee.keyDisplay)}></span>
                                    {ee.keyDisplay}
                                </span>
                            ))}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <Tabs defaultActiveKey={filterChatRoomTmp.selTab} onSelect={(key) => onFilterChange("TabPage", key)}>
                                {/* <Tab eventKey={FILTER_CHAT_ROOM_TABS.CHAT_ROOM} title={<><i className='bx bx-message-dots'></i>&nbsp;{FILTER_CHAT_ROOM_TABS.CHAT_ROOM}</>} >
                                    {Searching(FILTER_CHAT_ROOM_TABS.CHAT_ROOM, filter.keywordChatRoom)}
                                </Tab> */}
                                <Tab eventKey={FILTER_CHAT_ROOM_TABS.SALES} title={<><i className={'bx ' + (filteringSales ? 'bx-loader-alt bx-spin' : 'bx-user')}></i>&nbsp;{FILTER_CHAT_ROOM_TABS.SALES}</>}>
                                    {Searching(FILTER_CHAT_ROOM_TABS.SALES, filterChatRoomTmp.keywordSales)}
                                </Tab>
                                <Tab eventKey={FILTER_CHAT_ROOM_TABS.CS} title={<><i className={'bx ' + (filteringCs ? 'bx-loader-alt bx-spin' : 'bx-group')} ></i>&nbsp;{FILTER_CHAT_ROOM_TABS.CS}</>}>
                                    {Searching(FILTER_CHAT_ROOM_TABS.CS, filterChatRoomTmp.keywordCs)}
                                </Tab>
                                <Tab eventKey={FILTER_CHAT_ROOM_TABS.PROVINCE} title={<><i className={'bx ' + (filteringProvince ? 'bx-loader-alt bx-spin' : 'bx-map-alt')}></i>&nbsp;{FILTER_CHAT_ROOM_TABS.PROVINCE}</>}>
                                    {Searching(FILTER_CHAT_ROOM_TABS.PROVINCE, filterChatRoomTmp.keywordProvince)}
                                </Tab>
                            </Tabs>
                        </div>
                    </div>

                </Form>
            </ModalBody>
            <ModalFooter className="d-flex justify-content-between">
                <div className="d-flex justify-content-start">
                    <select className="form-select" value={filterChatRoomTmp.topRow} onChange={(e) => onFilterChange("DropDownTop", e.target.value)} >
                        <option value="50" >50 แถวแรก</option>
                        <option value="100" >100 แถวแรก</option>
                        <option value="200">200 แถวแรก</option>
                    </select>
                </div>
                {/* <Button type="button" color="secondary" className="btn" onClick={onClose} > ปิด </Button> */}
                <Button type="button" color="primary" onClick={onClickOk} >ตกลง</Button>
            </ModalFooter>
        </Modal >
    );
};

export default FilterChatRoomModal;
